import React, { useState, useRef } from 'react';
import './ImageZoom.css';

const ImageZoom = ({ src, alt, style }) => {
  const [isZoomed, setIsZoomed] = useState(false);
  const divElement = useRef(null); // Référence à la div parent pour obtenir la position de la souris
  const [zoomPosition, setZoomPosition] = useState({ x: 0, y: 0 });
  const [isZoomedLeft, setIsZoomedLeft] = useState(false); // Nouveau state pour savoir si le zoom est à gauche

  const handleMouseMove = (e) => {
    const { left, top, width, height } = divElement.current.getBoundingClientRect();
    const x = ((e.clientX - left) / width) * 100;
    const y = ((e.clientY - top) / height) * 100;
  
    setZoomPosition({ x, y });

    console.log(left + 440);
  
    setIsZoomedLeft(left - 440 > window.innerWidth / 5);
  };

  return (
    <div
      ref={divElement}
      className="image-zoom-container"
      onMouseEnter={() => (window.innerWidth >= 640) && setIsZoomed(true)}
      onMouseLeave={() => setIsZoomed(false)}
      onMouseMove={handleMouseMove}
    >
      <img style={{ width: '100%', height: '36%', ...style }} src={src} alt={alt} className="image-zoom" />
      {isZoomed && (
        <div
          className="zoomed-image"
          style={{
            backgroundImage: `url(${src})`,
            backgroundPosition: `${zoomPosition.x}% ${zoomPosition.y}%`,
            left: isZoomedLeft ? 'auto' : '100%', // Utilisez 'auto' si le zoom est à gauche
            right: isZoomedLeft ? '100%' : 'auto', // Utilisez '100%' si le zoom est à gauche
            transform: isZoomedLeft ? 'translateX(-20px)' : 'none', // Déplacez légèrement à gauche si nécessaire
          }}
        />
      )}
    </div>
  );
};

export default ImageZoom;
